import { LIVE_STATUSES } from "@/contants";

const STATUS_FINISHED = 8;

export function isLiveMatchStatus(status) {
  return LIVE_STATUSES.includes(Number(status));
}

export function isUpcomingTabStatus(status) {
  const n = Number(status);
  return !isLiveMatchStatus(n) && n !== STATUS_FINISHED && n !== -1;
}

function searchHaystack(match, group) {
  return [
    match.homeTeam?.name,
    match.homeTeam?.nameVN,
    match.awayTeam?.name,
    match.awayTeam?.nameVN,
    group.league?.name,
    group.league?.nameVN,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function filterLeaguesBySearchTerm(leagues, lowerQuery) {
  return leagues
    .map((group) => {
      const matches = (group.matches || []).filter((m) =>
        searchHaystack(m, group).includes(lowerQuery),
      );
      return matches.length ? { ...group, matches } : null;
    })
    .filter(Boolean);
}

export function filterLeagueGroupsByMatch(leagues, matchPredicate) {
  return leagues
    .map((g) => ({
      ...g,
      matches: (g.matches || []).filter(matchPredicate),
    }))
    .filter((g) => g.matches.length > 0);
}

export function groupMatchesByLeague(matches) {
  const byLeagueId = new Map();
  matches.forEach((m) => {
    const id = String(m.league?.id);
    if (!byLeagueId.has(id)) {
      byLeagueId.set(id, { league: m.league, matches: [] });
    }
    byLeagueId.get(id).matches.push(m);
  });
  return Array.from(byLeagueId.values());
}
